import { getEnv } from './env';
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: getEnv('REACT_APP_AZURE_CLIENT_ID')!, // Your Azure AD App Client ID
    authority: "https://login.microsoftonline.com/bd717aa1-6670-4ce3-ba94-ef01de50c477", // Your Azure AD Tenant ID
    redirectUri: window.location.origin + "/auth", // Dynamically grab the current URL (e.g. localhost or stagingk3s)
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

console.log("msalConfig.auth.redirectUri :" + msalConfig.auth.redirectUri)

// Define scopes - consistent across the application
export const scopes = [`${getEnv('REACT_APP_AZURE_CLIENT_ID')}/.default`];

export const loginRequest = {
  scopes: scopes,
};

// Create the MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize function - will be called from index.tsx
export const initializeMsal = async () => {
  try {
    // Initialize MSAL
    await msalInstance.initialize();
    console.log("MSAL initialized successfully");
    
    // Handle redirect promise
    const response = await msalInstance.handleRedirectPromise();
    
    // If response is non-null, user just completed auth
    if (response) {
      console.log("Redirect response received", response);
      msalInstance.setActiveAccount(response.account);
    } else {
      // If no response, check if we have any accounts
      const currentAccounts = msalInstance.getAllAccounts();
      if (currentAccounts.length > 0) {
        console.log("Account found in cache", currentAccounts[0]);
        msalInstance.setActiveAccount(currentAccounts[0]);
      }
    }
  } catch (error) {
    console.error("MSAL initialization failed", error);
    throw error;
  }
  
  return msalInstance;
};

// Add an event listener for login success with proper type checking
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    console.log("Login successful", event);
    
    // Need to check if payload is an AuthenticationResult
    if (event.payload && 'account' in event.payload) {
      const payload = event.payload as AuthenticationResult;
      if (payload.account) {
        msalInstance.setActiveAccount(payload.account);
      }
    }
  }
});

export default msalInstance;

